<template>
    <v-card flat>
        <div
            class="d-flex align-center justify-space-between px-3 pt-3 font-weight-600 font-size-18 border-bottom pb-3 mt-5"
        >
            <div>Daftar Konsultan</div>
            <div class="d-flex align-center gap-10">
                <v-btn
                    color="blew"
                    class="white--text px-3"
                    depressed
                    to="/konsul/consultant-form"
                >
                    <v-icon class="mr-1" small>mdi-plus-circle</v-icon>
                    Tambah Konsultan
                </v-btn>

                <v-btn
                    color="blew"
                    class="white--text px-3"
                    depressed
                    @click="fetchData()"
                >
                    <v-icon class="mr-1" small>mdi-cached</v-icon>
                    Sinkronisasi Data
                </v-btn>

                <v-card
                    outlined
                    color="#f9fafb"
                    class="d-flex align-center py-1 px-2 gap-5"
                    style="
                        width: 180px;
                        line-height: 0.8em;
                        border: 1.5px solid #eeeeee;
                    "
                >
                    <v-icon color="blew" small>mdi-information</v-icon>
                    <div class="font-size-12">
                        <div class="blew--text font-weight-bold">
                            Terakhir Diupdate
                        </div>
                        <div class="darkgrey--text font-size-11">
                            {{ updated_date }}
                        </div>
                    </div>
                </v-card>
            </div>
        </div>

        <div class="d-flex px-3 py-4 gap-10 border-bottom">
            <!-- <v-select
                v-model="search_category"
                :items="filter"
                item-text="label"
                item-value="value"
                placeholder="Filter"
                outlined
                dense
                hide-details
                style="max-width: 20%"
            ></v-select> -->

            <v-text-field
                v-model="search_value"
                placeholder="Ketik kata kunci dan tekan enter"
                dense
                outlined
                small
                hide-details
                append-icon="mdi-magnify"
            ></v-text-field>

            <!-- <v-select
                v-model="search_sort_by"
                :items="sort_by"
                item-text="label"
                item-value="value"
                placeholder="Sort By"
                outlined
                dense
                hide-details
                style="max-width: 15%"
                @change="onSearchData(1)"
            ></v-select>

            <v-select
                v-model="search_sort_type"
                :items="sort_type"
                item-text="label"
                item-value="value"
                placeholder="Sort Type"
                outlined
                dense
                hide-details
                style="max-width: 15%"
                @change="onSearchData(1)"
            ></v-select> -->
        </div>

        <v-data-table
            v-model="datatable"
            :headers="headers"
            :items="data"
            item-key="id"
            :loading="loading"
            :search="search_value"
            no-data-text="Data konsultan tidak tersedia"
        >
            <template v-slot:item.action="{ item }">
                <v-menu offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-list>
                            <v-list-item-group>
                                <v-list-item v-on:click="openDetail(item)">
                                    <v-list-item-title
                                        class="d-flex align-center gap-10"
                                    >
                                        <v-icon
                                            color="#6173e6"
                                            class="menu-icon"
                                        >
                                            mdi-forum
                                        </v-icon>
                                        Riwayat Konsul
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item
                                    v-on:click="
                                        $router.push(
                                            `/konsul/consultant-form?id=${item.id}`
                                        )
                                    "
                                >
                                    <v-list-item-title
                                        class="d-flex align-center gap-10"
                                    >
                                        <v-icon
                                            color="primary"
                                            class="menu-icon"
                                        >
                                            mdi-pencil-circle
                                        </v-icon>
                                        Edit
                                    </v-list-item-title>
                                </v-list-item>

                                <!-- <v-list-item
                                    v-on:click="cataloguingProcess(item)"
                                >
                                    <v-list-item-title
                                        class="d-flex align-center gap-10"
                                    >
                                        <v-icon color="red" class="menu-icon">
                                            mdi-close-circle
                                        </v-icon>
                                        Hapus
                                    </v-list-item-title>
                                </v-list-item> -->
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-menu>
            </template>

            <template v-slot:item.mapel="{ item }">
                <div>
                    {{ item.mapel.map((m) => m.mapel_name).join(", ") }}
                </div>
            </template>

            <template v-slot:item.online_status="{ item }">
                <v-chip
                    v-if="item.online_status === 'offline'"
                    class="font-weight-600 pl-0"
                    small
                    color="#d7dfe9"
                    text-color="#afbaca"
                >
                    <v-icon style="margin-right: -3px"
                        >mdi-circle-medium</v-icon
                    >
                    Offline
                </v-chip>

                <v-chip
                    v-if="item.online_status === 'online'"
                    class="font-weight-600 pl-0"
                    small
                    color="#e2f5ea"
                    text-color="#00cf3f"
                >
                    <v-icon style="margin-right: -3px"
                        >mdi-circle-medium</v-icon
                    >
                    Online
                </v-chip>

                <v-chip
                    v-if="item.online_status === 'busy'"
                    class="font-weight-600 pl-0"
                    small
                    color="#ffcccf"
                    text-color="#eb3123"
                >
                    <v-icon style="margin-right: -3px"
                        >mdi-circle-medium</v-icon
                    >
                    Sibuk
                </v-chip>
            </template>

            <template v-slot:item.consultant_status="{ item }">
                <v-chip
                    v-if="item.consultant_status"
                    class="font-weight-600 pl-0"
                    small
                    color="#e2f5ea"
                    text-color="#00cf3f"
                >
                    <v-icon style="margin-right: -3px"
                        >mdi-circle-medium</v-icon
                    >
                    Aktif
                </v-chip>

                <v-chip
                    v-else
                    class="font-weight-600 pl-0"
                    small
                    color="#d7dfe9"
                    text-color="#afbaca"
                >
                    <v-icon style="margin-right: -3px"
                        >mdi-circle-medium</v-icon
                    >
                    Nonaktif
                </v-chip>
            </template>

            <template v-slot:no-results>
                <div class="text-center">
                    <p class="my-2">Hasil pencarian tidak ditemukan.</p>
                </div>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
// import AppSpinner from "@/modules/global/components/plugins/Spinner";
// import KonsulServices from "@/modules/konsul/services/konsul.js";
// import Moment from "moment";
import axios from "axios";

export default {
    name: "consultant-management-table",
    props: {
        dataStatus: {
            type: Array,
            required: true,
        },
    },

    components: {
        // "app-spinner": AppSpinner,
    },

    data() {
        return {
            loading: false,
            datatable: null,
            search_value: null,
            headers: [
                { text: "Aksi", value: "action", sortable: false, width: 100 },
                {
                    text: "Nama Konsultan",
                    value: "name",
                    width: 200,
                },
                { text: "Email", value: "email", width: 120 },
                { text: "No. Handphone", value: "no_handphone", width: 150 },
                {
                    text: "Lama Mengajar",
                    value: "years_experience",
                    width: 140,
                },
                { text: "Alumni", value: "university", width: 150 },
                {
                    text: "Mata Pelajaran",
                    value: "mapel",
                    width: 150,
                },
                {
                    text: "Status Aplikasi",
                    value: "online_status",
                    sortable: false,
                    width: 120,
                },
                {
                    text: "Status Konsultan",
                    value: "consultant_status",
                    sortable: false,
                    width: 130,
                },
            ],
            params: {
                page: 1,
                limit: 1000,
                sort_by: null,
                sort_type: null,
            },
            filter: [
                {
                    value: "name",
                    label: "Nama Konsultan",
                },
            ],
            sort_by: [
                {
                    value: "createdAt",
                    label: "Created Date",
                },
                {
                    value: "name",
                    label: "Nama Konsultan",
                },
            ],

            sort_type: [
                {
                    value: "asc",
                    label: "asc",
                },
                {
                    value: "desc",
                    label: "desc",
                },
            ],
            data: [],
            updated_date: this.$moment().format("YYYY/MM/DD HH:mm"),
        };
    },

    mounted() {
        this.fetchData();
    },

    watch: {},

    methods: {
        onSearchData(newPage) {
            this.params = {
                page: newPage || 1,
                limit: 1000,
                search: this.search_value,
            };

            this.page = newPage;

            this.fetchData();
        },

        fetchData() {
            const url = `${process.env.API_BASE_URL}konsul/admin/get-list-consultant`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading = true;

            axios
                .get(url, {
                    params: this.params,
                    ...options,
                })
                .then(function (response) {
                    var data = [];
                    self.updated_date = self
                        .$moment()
                        .format("YYYY/MM/DD HH:mm");

                    response.data.forEach((doc) => {
                        var consultant =
                            self.dataStatus.find(
                                (e) =>
                                    e.email &&
                                    doc.email &&
                                    e.email.toLowerCase() ===
                                        doc.email.toLowerCase()
                            ) || null;

                        doc.online_status = consultant
                            ? consultant.status
                            : "offline";

                        data.push(doc);
                    });

                    self.data = self.sortOrderedConsultant(data) || [];
                })
                .finally(() => {
                    self.loading = false;
                });
        },

        getStatus(email) {
            const status =
                this.dataStatus.find((e) => e.email === email).status ||
                "offline";

            return status;
        },

        sortOrderedConsultant(data) {
            var ordered = _.orderBy(
                data,
                [
                    (item) => {
                        switch (item.online_status) {
                            case "online":
                                return 1;
                            case "busy":
                                return 2;
                            case "offline":
                                return 3;
                            default:
                                return 4;
                        }
                    },
                    "is_new_teacher",
                ],
                ["asc", "desc"]
            );

            return ordered;
        },

        openDetail(data) {
            this.$router.push({
                path: "/konsul/history",
                query: { teacher_id: data.id },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// ConsultantManagementTable.vue?6c6da0a4